import * as ActionTypes from './actionTypes';

/**
 * @param {string} message
 */
export function UIShowAlert (message) {
  return dispatch => dispatch({ type: ActionTypes.UI_SHOW_ALERT, message });
}

export function UIHideAlert () {
  return dispatch => dispatch({ type: ActionTypes.UI_HIDE_ALERT });
}

/**
 * @param {string} message
 * @param {function} confirmAction
 * @param {object} [uiProps]
 * @param {string} [uiProps.cancelButtonLabel]
 * @param {string} [uiProps.proceedButtonLabel]
 */
export function UIShowConfirm (message, confirmAction, uiProps) {
  return dispatch => dispatch({ type: ActionTypes.UI_SHOW_CONFIRM, message, confirmAction, uiProps });
}

export function UIHideConfirm () {
  return dispatch => dispatch({ type: ActionTypes.UI_HIDE_CONFIRM });
}



// WEBPACK FOOTER //
// ./src/actions/ui.js